'use client'

import { useCallback } from 'react'

import { useAdminStore } from '@/lib/auth/admin-store'
import { PERMISSION, PERMISSIONS } from '@/lib/auth/permissions'
import { hasPermission as hasPermissionUtil } from '@/lib/auth/permissions-utils'

export const usePermissions = () => {
  const adminPermissions = useAdminStore((state) => state.adminPermissions)
  const isAdminLoading = useAdminStore((state) => state.isAdminLoading)

  const hasPermission = useCallback(
    (permission: PERMISSION): boolean => {
      if (isAdminLoading) return false
      return hasPermissionUtil(adminPermissions, permission)
    },
    [isAdminLoading, adminPermissions]
  )

  const isAdmin = useCallback(
    (): boolean => hasPermissionUtil(adminPermissions, PERMISSIONS.SUPER_ADMIN),
    [adminPermissions]
  )

  return { adminPermissions, hasPermission, isAdmin, isAdminLoading }
}
